export function Footer() {
	return (
		<footer className="relative overflow-hidden">
			{/* Gradient background */}
			<div className="absolute inset-0 bg-gradient-to-b from-blue-700 to-blue-500" />

			{/* Content */}
			<div className="relative mx-auto max-w-7xl px-6 lg:px-8">
				{/* Main footer content */}
				<div className="pt-8 pb-8">
					<div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
						{/* Privacy Policy & Terms - Left */}
						<div className="md:flex-1 flex gap-4">
							<a
								href="/policy"
								className="text-white hover:text-blue-200 transition-colors font-medium"
							>
								Privacy Policy
							</a>
							<span className="text-blue-100">|</span>
							<a
								href="/terms"
								className="text-white hover:text-blue-200 transition-colors font-medium"
							>
								Terms & Conditions
							</a>
						</div>

						{/* Copyright - Center */}
						<div className="text-center md:flex-1">
							<p className="text-sm text-blue-100">
								Copyright © {new Date().getFullYear()} LoadFetcher by Fierce Trade LLC
							</p>
							<p className="text-xs text-blue-200 mt-1">
								30 N Gould St, Ste R Sheridan, WY 82801
							</p>
						</div>

						{/* Social Links - Right */}
						<div className="md:flex-1 flex justify-end">
							<div className="flex items-center space-x-6">
								<a
									href="https://t.me/loadfetcher_support"
									target="_blank"
									rel="noopener noreferrer"
									className="text-white hover:text-blue-200 transition-colors"
									aria-label="LoadFetcher on Telegram"
								>
									<svg
										className="h-6 w-6"
										fill="currentColor"
										viewBox="0 0 24 24"
										version="1.1"
									>
										<path
											id="telegram-1"
											d="M18.384,22.779c0.322,0.228 0.737,0.285 1.107,0.145c0.37,-0.141 0.642,-0.457 0.724,-0.84c0.869,-4.084 2.977,-14.421 3.768,-18.136c0.06,-0.28 -0.04,-0.571 -0.26,-0.758c-0.22,-0.187 -0.525,-0.241 -0.797,-0.14c-4.193,1.552 -17.106,6.397 -22.384,8.35c-0.335,0.124 -0.553,0.446 -0.542,0.799c0.012,0.354 0.25,0.661 0.593,0.764c2.367,0.708 5.474,1.693 5.474,1.693c0,0 1.452,4.385 2.209,6.615c0.095,0.28 0.314,0.5 0.603,0.576c0.288,0.075 0.596,-0.004 0.811,-0.207c1.216,-1.148 3.096,-2.923 3.096,-2.923c0,0 3.572,2.619 5.598,4.062Zm-11.01,-8.677l1.679,5.538l0.373,-3.507c0,0 6.487,-5.851 10.185,-9.186c0.108,-0.098 0.123,-0.262 0.033,-0.377c-0.089,-0.115 -0.253,-0.142 -0.376,-0.064c-4.286,2.737 -11.894,7.596 -11.894,7.596Z"
										/>
									</svg>
								</a>

								<a
									href="https://twitter.com/loadfetcher"
									target="_blank"
									rel="noopener noreferrer"
									className="text-white hover:text-blue-200 transition-colors"
									aria-label="LoadFetcher on X"
								>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										className="h-6 w-6"
										fill="currentColor"
										viewBox="0 0 24 24"
									>
										<path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
									</svg>
								</a>

								<a
									href="https://www.instagram.com/loadfetcher"
									target="_blank"
									rel="noopener noreferrer"
									className="text-white hover:text-blue-200 transition-colors"
									aria-label="LoadFetcher on Instagram"
								>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										className="h-6 w-6"
										fill="currentColor"
										viewBox="0 0 24 24"
									>
										<path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
									</svg>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</footer>
	)
}
